module.exports = __webpack_public_path__ + "static/media/playlist-tile.d9144a47.svg";